<template>

<v-app>
    <TopBar  />
    <LeftMenu ></LeftMenu>
    <Vtoast ref="Vtoast" :callBack="vtoastCallback" />

    <div class="pa-5" >
      
      <v-card elevation="0" outlined>
        <v-card-title>CREATE NEW STUDENT</v-card-title>

        <div class="pa-5"> 
          <v-form ref="form" >
            <v-text-field v-model="studentName" outlined label="Name Surname"  ></v-text-field>
            <v-text-field v-model="studentEmail" outlined label="Email Address"  ></v-text-field>
            <v-text-field v-model="studentPassword" outlined label="Password"  ></v-text-field>
          </v-form>
        </div>

        <v-card-actions class="pt-0" >
          <v-spacer></v-spacer>
          <v-btn to="/eisadmin/students" color="error" small elevation="0" class="mb-2 mr-2 mt-2" >CANCEL</v-btn>
          <v-btn class="float-right" @click="submit" small color="primary" elevation="0" >CREATE</v-btn>
        </v-card-actions>

      </v-card>

    </div>

</v-app>

</template>

<script>

  import checkAuth from '../../mixins/checkAuth';
  import LeftMenu from '../../views/eisadmin/components/LeftMenu'
  import TopBar from '../../views/eisadmin/components/TopBar'
  import { mdiMagnify, mdiBellOutline, mdiGithub, mdiAlertRhombus, mdiCheckBold
  } from '@mdi/js'
  import axios from 'axios';
  import Vtoast from '../../views/eisadmin/components/Vtoast';


  export default {
    mixins: [checkAuth],
    components: { LeftMenu, TopBar, Vtoast },

    setup() {
      return {
        icons: {
          mdiMagnify, mdiBellOutline, mdiGithub,},
      }
    },

    data: () => ({
      valid: true,
      studentName: '',
      studentEmail: '',
      studentPassword: '',
    }),

    methods: {
      getSchoolsData() {
        
        const data = { page : 0 }
        axios.post(process.env.VUE_APP_API_DOMAIN + "/schools",JSON.stringify(data)
        ,{ headers: {'Authorization': 'Bearer ' + this.$store.getters.getAccessToken } })
        .then(
          response => {
            this.schools = response.data.schools;
          }  
        );

      },
      submit () {
        
        if(this.studentName == "" || this.studentEmail == "" || this.studentPassword == ""){
          this.$root.Vtoast.show({message: 'Please fill all information!', snackType: 'fail', color: 'warning', icon: mdiAlertRhombus})
        }else{
          
          const data = {
            studentName : this.studentName,
            studentEmail : this.studentEmail,
            studentPassword : this.studentPassword,
          }

          axios.post(process.env.VUE_APP_API_DOMAIN + "/student_add",JSON.stringify(data)
          ,{
              headers: {
                'Authorization': 'Bearer ' + this.$store.getters.getAccessToken  
              }
            }
          ).then(
            response => {

              if(response.data.result == "success"){
                this.$root.Vtoast.show({message: 'Student is added successfully!', snackType: 'success', color: 'success', icon: mdiCheckBold })
              }else{
                this.$root.Vtoast.show({message: 'An error occurred!', snackType: 'fail', color: 'warning', icon: mdiAlertRhombus})
              }

            }  

          );
          
        }

      },
      vtoastCallback() {
        //vtoastCallback
        this.$router.push('/eisadmin/students');
      }
      
    },


    created() {

    },
    mounted() {
      this.$root.Vtoast = this.$refs.Vtoast;
      this.getSchoolsData();
    },
  }
</script>
